import graphQLAdapter from "@/adapters/graphQL.adapter.js";

/**
 * Character Service Class
 *
 * @export
 * @class
 */
export default class {
  constructor () {
    // eslint-disable-next-line
    this.adapter = new graphQLAdapter();
    this.getSankritCharacters = getSankritCharacters.bind(this);
  }

  /**
   * Get the list of characters
   *
   * @static
   * @returns {Promise<Object|null>} Promise object represents the list of characters
   */
  async list () {
    const res = await this.getSankritCharacters();

    return res;
  }
}

function getSankritCharacters () {
  const query = `{ sanskritCharacters{
    id
    sect
    imageUrl
    imageUrlForTablet
    inputCode
  }}`;

  return this.adapter.query(query);
}
